module.exports = __webpack_public_path__ + "static/img/gyb.1b816a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/gyb.png
// module id = QLQj
// module chunks = 93